module.exports = __webpack_public_path__ + "0ac6d764b9d22a3dca0d3469d38cd2ae.svg";